import { makeStyles } from "@material-ui/core";

export const ordersStyles = makeStyles((theme) => ({
  orderRoot: {
    padding: theme.spacing(1),
  },
  avatar: {
    color: "#333",
    backgroundColor: "white",
    border: "1px solid lightGrey",
    width: "50px",
    display: "flex",
    paddingTop: "5px",
    height: "25px",
  },
  Tooltip: {
    backgroundColor: "white",
    color: "black",
    boxShadow: `0 1px 2px ${theme.palette.primary.main}`,
  },
}));
